import { Clock } from "lucide-react";

export const ServiceBar = ({ service }) => {
  if (!service) return null;
  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 text-[11px] ${service.open ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`} data-testid="chat-service-bar">
      <Clock className="h-3.5 w-3.5 shrink-0" />
      <span className="flex-1">
        <b data-testid="chat-service-status">{service.open ? "Admin sedang online" : service.holiday ? `Libur: ${service.holiday}` : "Di luar jam layanan"}</b>
        {" • "}<span data-testid="chat-service-hours">{service.hours}</span>
        {!service.open && <> • dibalas {service.next_open_label}</>}
      </span>
    </div>
  );
};
